<script>
  import { surveyStore } from '../../stores/surveyStore.js';
  import { getQuestionData } from '../../utils/recommendationLogic.js';
  import { GA4Events } from '../../services/api.js';
  
  import ProgressBar from './ProgressBar.svelte';
  import InfoSlide from './InfoSlide.svelte';
  import Question from './Question.svelte';
  import LoadingAnimation from '../LoadingAnimation.svelte';
  import ResultsPage from './ResultsPage.svelte';
  import EmailCapture from './EmailCapture.svelte';
  import FAQScreen from './FAQScreen.svelte';
  import SuccessScreen from './SuccessScreen.svelte';
  
  $: state = $surveyStore;
  
  const questionData = getQuestionData();
  
  // Navigation handlers
  function goToQ2() {
    surveyStore.goToScreen('q2', 2);
  }
  
  function goToQ3() {
    surveyStore.goToScreen('q3', 3);
  }
  
  function goToQ4() {
    surveyStore.goToScreen('q4', 4);
  }
  
  function goToLoading() {
    GA4Events.surveyCompleted(state.recommendation || { plan: 'calculating' });
    surveyStore.goToScreen('loading', 4);
  }
  
  function goBackToQ1() {
    surveyStore.goToScreen('q1', 1);
  }
  
  function goBackToQ2() {
    surveyStore.goToScreen('q2', 2);
  }
  
  function goBackToQ3() {
    surveyStore.goToScreen('q3', 3);
  }
</script>

<div class="app">
  <header class="header">
    <div class="wordmark">
      Cleveland <span>Sirens</span>
    </div>
    <ProgressBar currentStep={state.currentStep} />
  </header>
  
  <div id="screen-container">
    {#if state.currentScreen === 'edu'}
      <InfoSlide />
      
    {:else if state.currentScreen === 'q1'}
      <Question 
        questionData={questionData.q1} 
        questionNumber="q1"
        onNext={goToQ2}
      />
      
    {:else if state.currentScreen === 'q2'}
      <Question 
        questionData={questionData.q2} 
        questionNumber="q2"
        onBack={goBackToQ1}
        onNext={goToQ3}
      />
      
    {:else if state.currentScreen === 'q3'}
      <Question 
        questionData={questionData.q3} 
        questionNumber="q3"
        onBack={goBackToQ2}
        onNext={goToQ4}
      />
      
    {:else if state.currentScreen === 'q4'}
      <Question 
        questionData={questionData.q4} 
        questionNumber="q4"
        onBack={goBackToQ3}
        onNext={goToLoading}
      />
      
    {:else if state.currentScreen === 'loading'}
      <LoadingAnimation />
      
    {:else if state.currentScreen === 'result'}
      {#if state.recommendation}
        <ResultsPage recommendation={state.recommendation} />
      {/if}
      
    {:else if state.currentScreen === 'emailCapture'}
      <EmailCapture captureType="transactional" />
      
    {:else if state.currentScreen === 'emailCaptureMarketing'}
      <EmailCapture captureType="marketing" />
      
    {:else if state.currentScreen === 'faq'}
      <FAQScreen />
      
    {:else if state.currentScreen === 'success'}
      <SuccessScreen emailCaptureType={state.emailCaptureType || 'transactional'} />
    {/if}
  </div>
</div>
